import React from 'react';
import { JobItem } from 'domains/workspaceDomain';
import { RevxSkeleton } from 'components';
import { useRole } from 'hooks';
import useJobCardTabShippingBilling from '../../../../hooks/useJobCardTabShippingBilling';
import useJobCardInfo from '../../../../hooks/useJobCardInfo';
import ShippingBillingProducer from './components/ShippingBillingProducer';
import ShippingBillingCustomer from './components/ShippingBillingCustomer';
import { hasCostDistribution } from './components/CostDistributionDisplay';
import './ShippingBilling.less';

const CommonShippingBilling = (jobData: JobItem) => {
  const { data, loading } = useJobCardTabShippingBilling(jobData.id);
  const { hasProducer } = useJobCardInfo(jobData);
  const { supplierRole, buyerRole } = useRole();
  // Cost distributed jobs are billed through Oracle, so suppliers and buyers
  // are not shown any price on this tab. Sourcers keep seeing everything.
  const hidePrice =
    (supplierRole || buyerRole) && hasCostDistribution(data?.costDistribution);
  return (
    <div className="shipping-billing">
      <RevxSkeleton loading={loading}>
        {hasProducer ? (
          <ShippingBillingProducer
            jobData={jobData}
            data={data}
            hidePrice={hidePrice}
          />
        ) : (
          <ShippingBillingCustomer
            jobData={jobData}
            data={data}
            hidePrice={hidePrice}
          />
        )}
      </RevxSkeleton>
    </div>
  );
};
export default CommonShippingBilling;
